/**
 * Utilidades para formateo de asientos
 */

/**
 * Mapeo de compositeId de palcos a números de palco correctos
 * Basado en la lógica de generación de palcos en useSeats.js
 */
const PALCO_NUMBER_MAP = {
  // Primera secuencia: IZQ2-DER1 alternando por filas (1-12)
  'BOX-1-L2': 1,   // Palco izquierdo columna 2, fila 1
  'BOX-1-R1': 2,   // Palco derecho columna 1, fila 1
  'BOX-3-L2': 3,   // Palco izquierdo columna 2, fila 3
  'BOX-3-R1': 4,   // Palco derecho columna 1, fila 3
  'BOX-5-L2': 5,   // Palco izquierdo columna 2, fila 5
  'BOX-5-R1': 6,   // Palco derecho columna 1, fila 5
  'BOX-7-L2': 7,   // Palco izquierdo columna 2, fila 7
  'BOX-7-R1': 8,   // Palco derecho columna 1, fila 7
  'BOX-9-L2': 9,   // Palco izquierdo columna 2, fila 9
  'BOX-9-R1': 10,  // Palco derecho columna 1, fila 9
  'BOX-11-L2': 11, // Palco izquierdo columna 2, fila 11
  'BOX-11-R1': 12, // Palco derecho columna 1, fila 11
  
  // Segunda secuencia: IZQ1-DER2 alternando por filas (1-11)
  'BOX-1-L1': 13,  // Palco izquierdo columna 1, fila 1
  'BOX-1-R2': 14,  // Palco derecho columna 2, fila 1
  'BOX-3-L1': 15,  // Palco izquierdo columna 1, fila 3
  'BOX-3-R2': 16,  // Palco derecho columna 2, fila 3
  'BOX-5-L1': 17,  // Palco izquierdo columna 1, fila 5
  'BOX-5-R2': 18,  // Palco derecho columna 2, fila 5
  'BOX-7-L1': 19,  // Palco izquierdo columna 1, fila 7
  'BOX-7-R2': 20,  // Palco derecho columna 2, fila 7
  'BOX-9-L1': 21,  // Palco izquierdo columna 1, fila 9
  'BOX-9-R2': 22,  // Palco derecho columna 2, fila 9
  'BOX-11-L1': 23, // Palco izquierdo columna 1, fila 11
  'BOX-11-R2': 24, // Palco derecho columna 2, fila 11
  
  // Tercera secuencia: IZQ1-DER2 para filas 13,15 (25-28)
  'BOX-13-L1': 25, // Palco izquierdo columna 1, fila 13
  'BOX-13-R2': 26, // Palco derecho columna 2, fila 13
  'BOX-15-L1': 27, // Palco izquierdo columna 1, fila 15
  'BOX-15-R2': 28, // Palco derecho columna 2, fila 15
};

/**
 * Formatear compositeId para mostrar información legible
 * @param {string} compositeId - ID compuesto del asiento (ej: "PB-1-2", "BOX-1-L2")
 * @returns {string} - Descripción legible del asiento
 */
export const formatSeatId = (compositeId) => {
  const parts = compositeId.split('-');
  if (parts.length === 3) {
    if (parts[0] === 'BOX') {
      // Para palcos, usar el mapeo correcto
      const palcoNumber = PALCO_NUMBER_MAP[compositeId];
      if (palcoNumber) {
        return `Palco ${palcoNumber}`;
      }
      // Fallback si no está en el mapeo
      return `Palco ${parts[1]}`;
    } else {
      const section = parts[0] === 'PB' ? 'Planta Baja' : 
                     parts[0] === 'PP' ? 'Primer Piso' : parts[0];
      const row = parts[1];
      const seat = parts[2];
      return `${section} - Fila ${row} - Asiento ${seat}`;
    }
  }
  return compositeId;
};

/**
 * Obtener el número de palco correcto desde un compositeId
 * @param {string} compositeId - ID compuesto del palco (ej: "BOX-1-L2")
 * @returns {number|null} - Número del palco o null si no es un palco válido
 */
export const getPalcoNumber = (compositeId) => {
  return PALCO_NUMBER_MAP[compositeId] || null;
};

/**
 * Verificar si un compositeId corresponde a un palco
 * @param {string} compositeId - ID compuesto del asiento
 * @returns {boolean} - true si es un palco
 */
export const isPalco = (compositeId) => {
  return compositeId.startsWith('BOX-');
};





